// extracted by mini-css-extract-plugin
export var brandName = "DetailProduct_brandName__ZANk0";
export var btnProductsDetail = "DetailProduct_btnProductsDetail__snMCu";
export var buttonWrapper = "DetailProduct_buttonWrapper__Nsx3C";
export var buttons = "DetailProduct_buttons__lpg+C";
export var container = "DetailProduct_container__QGfsa";
export var data = "DetailProduct_data__JCurr";
export var description = "DetailProduct_description__j7tZZ";
export var detailProduct = "DetailProduct_detailProduct__K3hpF";
export var hasSaveChangeButton = "DetailProduct_hasSaveChangeButton__b4zPj";
export var image = "DetailProduct_image__l-1nV";
export var imageContainer = "DetailProduct_imageContainer__Lg2yZ";
export var quantity = "DetailProduct_quantity__vrglC";
export var replacementTag = "DetailProduct_replacementTag__EZvrt";
export var saveChangesButton = "DetailProduct_saveChangesButton__4-k3s";
export var sizeInfo = "DetailProduct_sizeInfo__qubPa";
export var status = "DetailProduct_status__XPq6+";
export var subscriptionContainer = "DetailProduct_subscriptionContainer__KV+kV";
export var title = "DetailProduct_title__2vkBg";
export var unavailable = "DetailProduct_unavailable__Z-olt";